import React from 'react'
import PropTypes from 'prop-types'
import { FilterMenuItem, SearchableCheckboxes, HiddenLegend } from 'components'
import { CheckboxGroup } from 'lp-components'
import { isEmpty } from 'lodash'
import { Field } from 'redux-form'
import { formatOptions, serializeOptions } from 'utils'

const propTypes = {
  filterOptions: PropTypes.object.isRequired,
  applyFilter: PropTypes.func.isRequired,
}

const defaultProps = {}

function LearningHubPostsFilterFields({
  filterOptions,
  applyFilter,
  ...filterMenuProps
}) {
  return (
    <React.Fragment>
      {!isEmpty(filterOptions.discussionTypes) && (
        <FilterMenuItem
          name="types"
          displayName="Type"
          applyFilter={applyFilter}
          {...filterMenuProps}
          className="large-width full-height"
        >
          <Field
            name="types"
            component={CheckboxGroup}
            labelComponent={HiddenLegend}
            options={formatOptions(filterOptions.discussionTypes)}
          />
        </FilterMenuItem>
      )}
      {!isEmpty(filterOptions.disciplines) && (
        <FilterMenuItem
          name="disciplineIds"
          displayName="Discipline"
          applyFilter={applyFilter}
          {...filterMenuProps}
          className="large-width full-height"
        >
          <Field
            name="disciplineIds"
            component={CheckboxGroup}
            labelComponent={HiddenLegend}
            options={formatOptions(filterOptions.disciplines)}
          />
        </FilterMenuItem>
      )}
      {!isEmpty(filterOptions.topics) && (
        <FilterMenuItem
          name="topicIds"
          displayName="Topic Tags"
          applyFilter={applyFilter}
          {...filterMenuProps}
          className="large-width full-height"
        >
          <SearchableCheckboxes
            fieldName="topicIds"
            fieldLabel="Topic Tags"
            options={serializeOptions(filterOptions.topics, {
              key: 'key',
              value: 'value',
            })}
          />
        </FilterMenuItem>
      )}
      {!isEmpty(filterOptions.schoolTypes) && (
        <FilterMenuItem
          name="schoolType"
          displayName="School Type"
          applyFilter={applyFilter}
          {...filterMenuProps}
          className="large-width full-height"
        >
          <Field
            name="schoolType"
            component={CheckboxGroup}
            labelComponent={HiddenLegend}
            options={formatOptions(filterOptions.schoolTypes)}
          />
        </FilterMenuItem>
      )}
      {!isEmpty(filterOptions.learningHubCourses) && (
        <FilterMenuItem
          name="learningHubCourseIds"
          displayName="Course"
          applyFilter={applyFilter}
          {...filterMenuProps}
          className="large-width full-height"
        >
          <SearchableCheckboxes
            fieldName="learningHubCourseIds"
            fieldLabel="Course"
            options={serializeOptions(filterOptions.learningHubCourses, {
              key: 'key',
              value: 'value',
            })}
          />
        </FilterMenuItem>
      )}
    </React.Fragment>
  )
}

LearningHubPostsFilterFields.propTypes = propTypes
LearningHubPostsFilterFields.defaultProps = defaultProps

export default LearningHubPostsFilterFields
